import { render } from "./ContactUs.vue?vue&type=template&id=f48e6e9c&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"

import "./ContactUs.vue?vue&type=style&index=0&id=f48e6e9c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\sthem\\source\\repos\\Insync\\Pamodzi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f48e6e9c"]])

export default __exports__